import { FontSizeHeadingKey, ISpacingProps } from '../../theme';
import { IText } from './Text.types';

export type THeadingLevel = 'h6' | 'h5' | 'h4' | 'h3' | 'h2' | 'h1';

export const VARIANT_TO_HEADING_LEVEL: Record<FontSizeHeadingKey, THeadingLevel> = {
  xsmall: 'h6',
  small: 'h5',
  medium: 'h4',
  large: 'h3',
  xlarge: 'h2',
  xxlarge: 'h1'
};

export interface IHeading extends IText, ISpacingProps {
  variant?: FontSizeHeadingKey;
  type?: string;
  /** If true, shows visible focus outline when programmatically focused (a11y requirement) */
  hasVisibleFocus?: boolean;
  colourGradient?: boolean;
}
